export const getErrorPayload = (error) => {
    if (!error || typeof error != 'object')
        return internalError;
    const axiosError = error;
    if (axiosError.response) {
        const responseCorrelationId = axiosError.response.headers?.['x-correlation-id'];
        return {
            ...axiosError.response.data,
            status: axiosError.response.status,
            correlationId: axiosError.response.data?.correlationId || responseCorrelationId
        };
    }
    else
        return internalError;
};
const internalError = {
    error: 'Internal error occured during request.',
    status: 500
};
